import { useAppSelector } from 'redux/toolkit/hooks'
import { UserRole } from 'config/userRole'

export const useIsReadonly = (): boolean =>
  useAppSelector(
    _stores =>
      _stores.auth.accessTokenObject?.roleType === UserRole.HELPDESK_ROLE ||
      _stores.auth.accessTokenObject?.isGuestUser === true
  )
